/**
 * Query params understood when linking straight to the product search, e.g.
 * /dashboard/product-search?outletId=466&productIds=3005721,2999510,2826054
 */
export const OUTLET_ID_QUERY_PARAM = 'outletId';
export const PRODUCT_IDS_QUERY_PARAM = 'productIds';
